import { NgModule } from '@angular/core';
import { GlobalErrorsService } from './global-errors.service';

@NgModule({
  providers: [GlobalErrorsService]
})
export class ServicesModule {
}
